// src/msalConfig.ts
import { Configuration, LogLevel } from '@azure/msal-browser';
import { urlUtils } from '@/pages/report/lib/urlUtils';

const IS_LOGGER_ACTIVE = false; // Set to false to disable logging

//current base url e.g. http://localhost:8080 or https://www.example.com
const currentUrl = urlUtils.getFrontendUrl();
const CLIENT_ID = process.env.MSAL_CLIENT_ID;
const AUTHORITY = process.env.MSAL_AUTHORITY;

const RISIKOPROFIL_SCOPE = process.env.RISIKOPROFIL_SCOPE;

const isProd = process.env.NODE_ENV === 'production';
if (!isProd) {
  console.log('Environment:', process.env.NODE_ENV);
  console.log('MSAL_CLIENT_ID:', CLIENT_ID);
  console.log('MSAL_AUTHORITY:', AUTHORITY);
  console.log('currentUrl:', currentUrl);
}

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    redirectUri: currentUrl,
    authority: AUTHORITY,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (!IS_LOGGER_ACTIVE) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: LogLevel.Info,
    },
  },
};

export const loginRequest = {
  //  scopes: ['User.Read', 'api://066efd25-9a43-4128-ac89-c8ed511f3335/access_as_user'], // Adjust scopes as needed
  scopes: [
    //'api://5cb373eb-ba12-4627-ac1a-e0a34327f9e7/access_as_user', // Risikoprofil - FE
    // 'api://066efd25-9a43-4128-ac89-c8ed511f3335/access_as_user', //Risikoprofil BACKEND
    //'api://066efd25-9a43-4128-ac89-c8ed511f3335/.default', //Risikoprofil BACKEND -> 2 fenster
    RISIKOPROFIL_SCOPE,
  ],
  // prompt: 'consent',

  // following scopes are default
  //  'openid',
  //  'profile',
  //  'email',
  //    'api://066efd25-9a43-4128-ac89-c8ed511f3335/access_as_user', //Risikoprofil BACKEND
  //'api://d88e0da7-38c9-4ea2-b394-7edaab61c5e0/efmapi_dev_access', // RE - BACKEND
  //'api://5cb373eb-ba12-4627-ac1a-e0a34327f9e7/access_as_user', // RCP - FE
};
